export default function Footer() {
  return (
    <div className="footer">
      <small>© 2022 Made by ChocoBanana.</small>
    </div>
  )
}